import React from 'react';
import { SvgIcon } from 'ui/SvgIcon';
import LoaderIcon from 'ui/Icons/tabler/loader.component.svg';
import classnames from 'classnames';

export interface ILoadingBarProps {
  className?: string;
  label?: string;
}

export const LoadingBar = (props: ILoadingBarProps) => {
  return (
    <div
      className={classnames('loading-bar w-full bg-yellow-20 p-4 flex items-center justify-center font-pt-sans mx-auto', props.className)}
      style={{
        // hardcoded colour as `yellow-20` converted to RGB
        background: `linear-gradient(
            to left,
            rgba(251, 245, 229, 0) 0%,
            rgba(251, 245, 229, 1) 10%,
            rgba(251, 245, 229, 1) 90%,
            rgba(251, 245, 229, 0) 100%
          )`,
        maxWidth: '300px', // specific rule from the style guide
      }}
    >
      <SvgIcon IconComponent={LoaderIcon} className="w-4 h-4 fill-transparent stroke-brown-140 stroke-2 animate-spin" />
      <span className="ml-2 text-yellow-100 text-sm">{props.label || 'Loading content...'}</span>
    </div>
  );
};

export interface IErrorBarProps {
  className?: string;
  message?: string;
  showCta?: boolean;
  ctaCaption?: string;
  onCtaClick?: () => void;
}

export const ErrorBar = React.memo((props: IErrorBarProps) => {
  const showCta = props.showCta ?? true;

  return (
    <div
      className={classnames('error-bar w-full bg-red-20 p-4 text-center font-pt-sans mx-auto', props.className ?? '')}
      style={{
        maxWidth: '300px', // specific rule from the style guide
      }}
    >
      <span className="error-bar-message block text-red-100 text-sm">{props.message || 'Failed to load content'}</span>
      {showCta && (
        <a
          className="mt-2 block text-red-100 text-sm underline cursor-pointer hover:text-red-100"
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            if (props.onCtaClick) {
              props.onCtaClick();
            } else {
              window.location.reload();
            }
          }}
        >
          {props.ctaCaption ? props.ctaCaption : 'Reload page'}
        </a>
      )}
    </div>
  );
});
